import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ApiRoutes } from '@sb/library/api';
import { DesignBlockBaseViewComponent, LoremIpsumText, PaginatorData, RandomEnumValue, WebsiteMode } from '@sb/library/base';
import { DesignBlockMode, EventColorEnum, NewsDisplayItem, NewsPostIconEnum, NewsPublishLocations, NewsSearchOptions, WebsiteBlockBlogDisplayItem } from '@sb/library/data-models';
import { SBDate } from '@sb/library/localization';
import { StyleManager } from '@sb/library/managers';

@Component({
    selector: 'lib-blog-posts-design-block',
    templateUrl: './blog-posts-design-block.component.html',
    styleUrls: ['./blog-posts-design-block.component.scss']
})
export class BlogPostsDesignBlockComponent extends DesignBlockBaseViewComponent implements OnInit, AfterViewInit {
    private _loading: boolean = true;
    private _blogSize: number = 0;
    private _stickyPosts: Array<NewsDisplayItem> = [];
    private _visiblePosts: Array<NewsDisplayItem> = [];
    private _allPostsLength: number | null = null;
    private _examplePosts: Array<NewsDisplayItem> = [];
    private _publishLocations: NewsPublishLocations = new NewsPublishLocations({Blog: true, StudentPortal: false, TeacherPortal: false});

    @Input() websiteBlockData!: WebsiteBlockBlogDisplayItem;

    constructor(private _StyleManager: StyleManager) {
        super();
        for (let i = 0; i <= 3; i++) {
            this._examplePosts.push(new NewsDisplayItem({
                Title: `Lorem Ipsum ${i+1}`,
                Author: 'Author',
                PublishDate: SBDate.Today().ToISO(),
                Sticky: i < 2,
                Icon: RandomEnumValue(NewsPostIconEnum),
                Color: RandomEnumValue(EventColorEnum),
                BodyHTML: LoremIpsumText.FourSentences
            }))
        }
    }

    ngAfterViewInit(): void {
        const searchOptions = new NewsSearchOptions({
            Sticky: true,
            EndDate: SBDate.Today().AddDays(1).ToISO(),
            PublishLocations: this._publishLocations
        });
        ApiRoutes.News.Search.Call({Parameter: (this.Scope.websiteMode === WebsiteMode.Live) ? this.schoolID: '', Body: searchOptions}).subscribe(data => {
            this._stickyPosts = data.ItemSubset;
            this.GetNews();
        });

    }

    GetNews(): void {
        this._loading = true;
        const searchOptions = new NewsSearchOptions({
            Sticky: false,
            EndDate: SBDate.Today().AddDays(1).ToISO(),
            PublishLocations: this._publishLocations
        });
        this._blogSize += 3;
        const paginatorData = new PaginatorData({
            PageSize: this._blogSize,
            PageNumber: 0
        })
        ApiRoutes.News.Search.Call({
            Parameter: (this.Scope.websiteMode === WebsiteMode.Live) ? this.schoolID : '',
            Body: searchOptions,
            PaginatorData: paginatorData
        }).subscribe(data => {
            this._visiblePosts = [...this._stickyPosts, ...data.ItemSubset];
            this._allPostsLength = this._stickyPosts.length + data.TotalItemCount;
            this._loading = false;
        });
    }

    GetBackgroundColor(post: NewsDisplayItem): string {
        return this._StyleManager.GetBackgroundColorCssClass(post.Color);
    }

    get schoolID(): string {
        return this.websiteBlockData.SchoolID!;
    }

    get visiblePosts(): Array<NewsDisplayItem> {
        return this.designBlockMode === DesignBlockMode.Sidebar ? this._examplePosts : this._visiblePosts;
    }

    get allPostsLength(): number | null {
        return this.designBlockMode === DesignBlockMode.Sidebar ? this._examplePosts.length : this._allPostsLength;
    }
}
